export const ACCOUNT_NO_LENGTH = 4
export const ACCOUNT_EXP = /^\d{4}$/

export enum AccountNoStatusEnum {
  inactive = 'inactive',
  active = 'active',
  cancelled = 'cancelled',
  reserved = 'reserved',
  available = 'available'
}
